import type { PickupOrderListItem } from '../types/pickupOrder.type';
import { monthOrderRange } from './dailyMaterials.helpers';

export interface OrderCompletion {
  completed: number;
  total: number;
}

/**
 * Pickup orders per branch and how many were completed — the dashboard's
 * completion rate (completed ÷ every order of the period, any status),
 * split by the order's collection site. Orders without a site count under
 * `unassignedKey`.
 */
export function orderCompletionBySite(
  orders: readonly PickupOrderListItem[],
  monthStart: Date | null,
  unassignedKey: string,
): Map<string, OrderCompletion> {
  const prefix = monthStart ? monthOrderRange(monthStart).prefix : null;
  const seen = new Set<string>();
  const bySite = new Map<string, OrderCompletion>();
  for (const order of orders) {
    if (!order?.id || seen.has(order.id)) continue;
    if (prefix && !(order.created_at ?? '').startsWith(prefix)) continue;
    seen.add(order.id);
    const key = order.collection_site_id || unassignedKey;
    const entry = bySite.get(key) ?? { completed: 0, total: 0 };
    entry.total += 1;
    if ((order.status ?? '').toLowerCase() === 'completed') entry.completed += 1;
    bySite.set(key, entry);
  }
  return bySite;
}

/** Completion rate in percent, or null when the branch had no orders. */
export function completionRatePercent(entry: OrderCompletion | undefined): number | null {
  return entry && entry.total > 0 ? (entry.completed / entry.total) * 100 : null;
}
